import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { EditBannerImageComponent } from 'app/components/edit-banner-image/edit-banner-image.component';

@Component({
  selector: 'app-manage-banner-images',
  templateUrl: './manage-banner-images.component.html',
  styleUrls: ['./manage-banner-images.component.css']
})
export class ManageBannerImagesComponent implements OnInit {

  bannerImages = []

  pages = [
    {value: 1, viewValue: 'Home Page'},
    {value: 2, viewValue: 'About Page'},
    {value: 3, viewValue: 'Contact Page'},
    {value: 4, viewValue: 'Blog Page'}
  ]

  constructor(private adminService: DataService, private dialog: MatDialog, private notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.adminService.getBannerImages().subscribe(data => {
      if(data.status){
        let bannerImages = data.homeBanners
        if(bannerImages.length){
          for(let ad of bannerImages){
            let page = this.pages.find(page => page.value == ad.page)
            ad['pageName'] = page.viewValue
            ad['imagePath'] = environment.api + '/images/' + ad['imagePath']
            this.bannerImages.push(ad)
          }
        }
      }
    })
  }

  addBannerImage(){
    const dialogRef = this.dialog.open(EditBannerImageComponent, {
      width: '600px',
      height: 'auto',
      data: {
        image: null,
        imagePath: '',
        page: 1,
        status: true,
        edit: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.adminService.addBannerImage(result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            let page = this.pages.find(page => page.value == data.homeBanner.page)
            data.homeBanner['pageName'] = page.viewValue
            data.homeBanner.imagePath = environment.api + '/images/' + data.homeBanner.imagePath
            this.bannerImages.push(data.homeBanner)
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  updateBannerImage(ad){
    const dialogRef = this.dialog.open(EditBannerImageComponent, {
      width: '600px',
      height: 'auto',
      data: {
        image: null,
        page: ad.page,
        imagePath: ad.imagePath,
        status: ad.status,
        edit: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(!result['image'])
          delete result['image']
        this.adminService.editBannerImage(ad.id, result).subscribe(data => {
          if(data.status){
            this.openNotification(data.message)
            let page = this.pages.find(page => page.value == data.homeBanner.page)
            data.homeBanner['pageName'] = page.viewValue
            data.homeBanner.imagePath = environment.api + '/images/' + data.homeBanner.imagePath
            this.bannerImages[this.bannerImages.indexOf(ad)] = data.homeBanner
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg , 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  deleteBannerImage(ad){
    this.adminService.deleteBannerImage(ad.id).subscribe(data => {
      if(data.status){
        let index = this.bannerImages.indexOf(ad)
        this.bannerImages.splice(index, 1)
        this.openNotification('Banner Image has been deleted!')
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

}
